module.exports = __webpack_public_path__ + "img/SearchBySplint.ad253534.gif";